@let assigneeName = normalizedName();
@let accessibleName = assigneeName || ('employees.serviceTaskBoard.unassigned' | translate);
<span
  [class]="'assignee-avatar assignee-avatar--' + size()"
  [attr.aria-label]="!decorative() && displayMode() === 'avatar' ? accessibleName : null"
  [matTooltip]="!decorative() && displayMode() === 'avatar' ? accessibleName : ''"
  [attr.role]="!decorative() && displayMode() === 'avatar' ? 'img' : null"
>
  <span class="assignee-avatar__circle" aria-hidden="true">
    @if (photoUrl(); as photoUrl) {
      <img class="assignee-avatar__photo" [src]="photoUrl" [alt]="decorative() ? '' : accessibleName" />
    } @else {
      <span class="assignee-avatar__initials">{{ initials() }}</span>
    }
  </span>

  @if (displayMode() === 'avatar-with-name') {
    <span class="assignee-avatar__name">{{ accessibleName }}</span>
  }
</span>
